// React
import React, {Component} from "react";
import {connect} from "react-redux";
// Routing
import {withRouter} from "react-router-dom";
// Translations
import {withTranslation} from "react-i18next";
// Svg
import {addSvg, minimizeSvg} from "assets";
// Components
import {Divider, Switch} from "@material-ui/core";
import {BillingAPI} from "views/Order/infrastructure";
// Application
import {showNotify} from "vendor/application/disptach";

class Tab02 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            whatsapp_interest: false
        };
    }

    interest = async () => {
        const {access, user} = this.props.data;

        var body = {
            channel: "whatsapp",
            origin: "shopping"
        };

        try {
            const obj = new BillingAPI(user.account_id, access, this.props, body);
            await obj.interest_intetrations();

            this.setState({whatsapp_interest: true});

        } catch (err) {
            var data = {message: err.responseJSON.message, from: "order", severity: "error"};
            this.props.dispatch(showNotify(data));
        }
    };

    render() {
        const {
            tab,
            products,
            currency,
            t,
            isInOrder,
            updateOrder,
            handleTabs,
            postContract,
            plan,
            updatePeriod,
            order,
            resume
        } = this.props;
        return (
            tab === 2 &&
            <React.Fragment>
                <span>{t("billing:tab_03.sub_title_01")}</span>
                {
                    resume && resume.plan &&
                    <div style={{margin: "0 0 30px 0px"}} className="switch">
                        <Divider></Divider>
                        <div>
                            <div>
                                <Switch checked={order.period === "annual" ? true : false} onClick={(e) => {
                                    updatePeriod(e);
                                }}/>
                                <p>{t("billing:annual_price")}</p>
                            </div>
                            <span>{resume.plan.annual}{t(`billing:currency_${currency}`)}</span>
                        </div>
                        <Divider></Divider>
                        <div>
                            <div>
                                <Switch checked={order.period === "monthly" ? true : false} onClick={(e) => {
                                    updatePeriod(e);
                                }}/>
                                <p>{t("billing:monthly_price")}</p>
                            </div>
                            <span>{resume.plan.monthly}{t(`billing:currency_${currency}`)}</span>
                        </div>
                        <Divider></Divider>
                    </div>
                }
                {
                    <React.Fragment>
                        <span>{t("billing:tab_02.sub_title_02")}</span>
                        <div className="man-billing_elements">
                            {
                                products.map((product, i) => {
                                    return (
                                        product.product_type === "integration" &&
                                        <div key={i}
                                             className={`${isInOrder(product.reference) ? "active" : "inactive"}`}>
                                            <div className="img">
                                                <img alt="centribot-integration"
                                                     src={`${process.env.PUBLIC_URL}/integrations_plans/${product.name}.svg`}/>
                                                <span>{t(`integrations:integrations.${product.name}.title`)}</span>
                                            </div>
                                            <div className={plan}>
                                                {isInOrder(product.reference) ?
                                                    <button onClick={(e) => updateOrder(e, product.reference)}>
                                                        {minimizeSvg()}
                                                    </button>
                                                    :
                                                    <button onClick={(e) => updateOrder(e, product.reference)}>
                                                        {addSvg()}
                                                    </button>
                                                }
                                                <div>
                                                    <span>{product.monthly_price[currency]}{t(`billing:currency_${currency}`)}</span>
                                                    <span>{t("billing:tab_02.price.monthly")}</span>
                                                </div>
                                                <div>
                                                    <span>{product.annual_price[currency]*12}{t(`billing:currency_${currency}`)}</span>
                                                    <span>{t("billing:tab_02.price.annual")}</span>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })
                            }
                        </div>
                    </React.Fragment>
                }
                <div className="man-actions order">
                    <span onClick={(e) => handleTabs(e, 1)}>{"< "}{t("inputs:button.back")}</span>
                    <button onClick={(e) => postContract(e)}
                            className="btn btn-green">{t("inputs:button.next")}</button>
                </div>
            </React.Fragment>


        );
    }
}

const mapStateToProps = state => {
    return {
        data: state
    };
};

const connect_ = connect(
    mapStateToProps
)(Tab02);
export default withTranslation(["order", "inputs", "billing"])(withRouter(connect_));